import React from 'react'
import { Flex, Label, TextInput, Popup } from '@leverege/ui-elements'
import FormRow from './FormRow'
import FontIconSelector from './FontIconSelector'

import style from './style.css'

export default function IconPopover( props ) {
  const { value, onChangeIcon, title = 'Set Icon' } = props
  const { onChangeFont = onChangeIcon, fontValue = value } = props

  return (
    <Popup
      toggleVariant="setIcon"
      className={style.setIconPopup}
      variant="setIcon"
      title={title}>
      <div>
        <Flex variant="rowM">
          <Label>URL</Label>
          <TextInput
            style={{ flexGrow : 1 }}
            hint="Icon URL..."
            value={value} 
            changeOnReturn 
            onChange={( { value } ) => onChangeIcon( value )} />
        </Flex> 
        <div style={{ textAlign : 'center' }}>OR</div>
        <div className={style.fontOptions}>
          <FormRow variant="rowM">
            <Label>Font</Label>
            <FontIconSelector
              style={{ flexGrow : 1 }}
              onSelect={onChangeFont}
              font={fontValue} />
          </FormRow>
        </div>
      </div>
    </Popup>
  )
}
